module.exports = __webpack_public_path__ + "static/media/GESSTwo400.08ad6d82.woff";